import { Module } from '../Module';

interface IFormattingHintsScope extends ng.IScope {
  showFormattingHints: boolean;
  showImageHint: boolean;
  showProjectImageHint: boolean;
}

Module.instance().directive('tbFormattingHints',
  () => {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        showImageHint: '<',
        showProjectImageHint: '<'
      },
      templateUrl: 'formattingHints.html',
      link:(scope: IFormattingHintsScope) => {}
    };
  }
);
